import { motion } from 'framer-motion';
import StepCard from './StepCard';
import GainsCard from './GainsCard';

export default function HowItWorks() {
  const steps = [
    {
      title: 'Hold RENT Tokens',
      description: 'Purchase and hold RENT tokens to participate in the real estate portfolio'
    },
    {
      title: 'Property Management',
      description: 'Professional management handles all property operations'
    },
    {
      title: 'Earn Passive Income',
      description: 'Receive monthly rental income distributions automatically'
    },
    {
      title: 'Portfolio Growth',
      description: 'Benefit from property value appreciation and portfolio expansion'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-primary mb-4">How It Works</h2>
          <p className="text-body-large text-gray-600 max-w-2xl mx-auto">
            Join RentFi and start earning passive income from our professionally managed real estate portfolio
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <StepCard key={index} {...step} index={index} />
          ))}
        </div>

        <GainsCard />
      </div>
    </section>
  );
}